// @ts-nocheck
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import { createHandlerChainRunner, HandlerWithResult } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = HandlerWithResult<
    {
        emailErrorMessage?: React.ReactNode;
        firstNameErrorMessage?: React.ReactNode;
        lastNameErrorMessage?: React.ReactNode;
    },
    {
        updatedUser?: AccountModel;
        emailErrorMessage?: React.ReactNode;
        firstNameErrorMessage?: React.ReactNode;
        lastNameErrorMessage?: React.ReactNode;
    }
>;

export const ValidateFields: HandlerType = props => {
    const state = props.getState();
    const { parameter } = props;
    props.result = {
        updatedUser: { ...getCurrentEditingUser(state) } as AccountModel,
        emailErrorMessage: parameter.emailErrorMessage ?? state.pages.userSetup.emailErrorMessage,
        firstNameErrorMessage: parameter.firstNameErrorMessage ?? state.pages.userSetup.firstNameErrorMessage,
        lastNameErrorMessage: parameter.lastNameErrorMessage ?? state.pages.userSetup.lastNameErrorMessage,
    };
};

export const DispatchSetUserFields: HandlerType = props => {
    props.dispatch({
        updatedUser: props.result.updatedUser,
        emailErrorMessage: props.result.emailErrorMessage,
        firstNameErrorMessage: props.result.firstNameErrorMessage,
        lastNameErrorMessage: props.result.lastNameErrorMessage,
        type: "Pages/UserSetup/SetUserFields",
    });
};

export const chain = [ValidateFields, DispatchSetUserFields];

const setUserFieldErrors = createHandlerChainRunner(chain, "SetUserFieldErrors");
export default setUserFieldErrors;
